import * as lazy from "./lazyRouteComponents";

export default [
  {
    path: "panels",
    name: "spage:panelList",
    component: lazy.PanelList
  },
  {
    path: "panels/:panelId",
    name: "spage:panelEdit",
    component: lazy.PanelEdit
  }
];
